import React from 'react'
import { shallow } from 'enzyme'
import { EtranDocument } from '../EtranDocument'
import business from '../../financial_review/specs/testData/business'

describe('EtranDocument', () => {
  let wrapper, props

  const docProps = {
    skipped: false,
    confirmed: false,
    status: 'pending_review',
    uploaded: false,
    skippable: false,
    referenceFiles: "[]",
    adminOnly: false,
    deletable: false,
    displayCommentable: false,
    esignable: false,
    live: true,
    rid: 123,
    title: 'title',
    type: 'Document::Custom',
    files: [
      {
        is_new: false,
        name: 'foo.jpg'
      }
    ]
  }

  beforeAll( () => {
    props = {
      superUser: true,
      loanId: 123,
      loan: {
        cre: false,
        appNumber: '123456'
      },
      entity: {
        borrowerType: 'oc'
      },
      document: {
        ...docProps,
        files: []
      },
      entityId: 123,
      client: {},
      resourceType: 'Archived'
    }
    wrapper = shallow(<EtranDocument {...props} />)
  })

  describe('#render', () => {
    it('should return obj', () => {
      expect(typeof wrapper).toBe('object')
    })
  })

  describe('#renderStatus', () => {
    // renderStatus = hasReferences => Boolean
    it('should return obj if no references', () => {
      const obj = wrapper.instance().renderStatus(false)
      expect(typeof obj).toBe('object')
      expect(JSON.stringify(obj)).toContain('children')
      expect(JSON.stringify(obj)).toContain('No Documents Uploaded')
    })
  })

  describe('#renderStatusFiles', () => {
    // renderStatusFiles = reference => Hash
    it('should return div if no reference or no files', () => {
      const obj = wrapper.instance().renderStatusFiles()
      expect(typeof obj).toBe('object')
      expect(JSON.stringify(obj)).toContain('No Documents Uploaded')
    })

    it('should return a status selector', () => {
      wrapper.setProps({
        document: {
          ...docProps,
          files: [{ name: 'one' }],
          fileUrls: [{ filename: 'one' }]
        }
      })
      const obj = wrapper.instance().renderStatusFiles({date: new Date(), status: 'PENDING_REVIEW'})
      expect(typeof obj).toBe('object')
      expect(JSON.stringify(obj)).toContain('status_select')
    })
  })

  describe('#renderContainer', () => {
    // renderContainer = reference => Hash
    it('should return obj', () => {
      const obj = wrapper.instance().renderContainer()
      expect(typeof obj).toBe('object')
    })

    it('should include title if reference', () => {
      const obj = wrapper.instance().renderContainer({date: new Date(2018, 3,18), status: 'PENDING_REVIEW'})
      expect(JSON.stringify(obj)).toContain('April 2018')
    })

    it('should render id', () => {
      const obj = wrapper.instance().renderContainer()
      expect(JSON.stringify(obj)).toContain('document_bucket_box')
    })
  })

  describe('#renderContainer', () => {
    // renderContainer = reference => Hash
    it('should return obj', () => {
      const obj = wrapper.instance().renderContainer()
      expect(typeof obj).toBe('object')
    })

    it('should include title if reference', () => {
      const obj = wrapper.instance().renderContainer({date: new Date(2018, 3,18), status: 'PENDING_REVIEW'})
      expect(JSON.stringify(obj)).toContain('April 2018')
    })

    it('should render id', () => {
      const obj = wrapper.instance().renderContainer()
      expect(JSON.stringify(obj)).toContain('document_bucket_box')
    })
  })

  describe('#updateDocumentData', () =>{
    let store
    beforeAll(() => {
      store = {
        readQuery: () => {
          return {}
        },
        writeQuery: () => {
          return true
        }
      }
    })

    it('should not redirect when state is not forms verified', () => {
      const url = wrapper.instance().updateDocumentData({}, store, 'forms_verified')
      expect(url).toBeFalsy()
    })
  })

  describe('#removeOption', () => {
    let options
    beforeEach(() => {
      const statusOptions = {
        esign_requested: 'E-Sign Requested',
        not_required:    'Not Required'
      }
      options = Object.keys(statusOptions)
    })

    it('removes option from the option list', () => {
      wrapper.instance().removeOption(options, 'esign_requested')
      expect(JSON.stringify(options)).not.toContain('esign_requested')
    })
  })

  describe('#renderOptions', () => {
    it('should not include move_to_archived option', () => {
      const object = wrapper.instance().renderOptions()
      expect(JSON.stringify(object)).not.toContain('move_to_archived')
      expect(JSON.stringify(object)).toContain('un_archive')
    })

    it('should not include un_archive option', () => {
      wrapper.setProps({ ...props, resourceType: 'Business',customerService: true})
      const object = wrapper.instance().renderOptions()
      expect(JSON.stringify(object)).toContain('move_to_archived')
      expect(JSON.stringify(object)).not.toContain('un_archive')
    })
  })

  describe('#getEntity', () => {
    it('returns the entity with entityId', () => {
      const object = wrapper.instance().getEntity(business.guarantors, business.guarantors[0].rid)
      expect(object).toEqual(business.guarantors[0])
    })
  })

  describe('#updateDocumentByIndex', () => {
    let document
    beforeEach(() => {
      document = {
        ...docProps,
        files: []
      }

      business.documents = [
        document
      ]
    })

    it('when status is pending_review', () => {
      const object = wrapper.instance().updateDocumentByIndex(business.documents, document.rid, 'pending_review', document)
      expect(business.documents.length).toEqual(1)
    })

    it('when status is un_archive', () => {
      const object = wrapper.instance().updateDocumentByIndex(business.documents, document.rid, 'un_archive', document)
      expect(business.documents.length).toEqual(0)
    })
  })

  describe('#documentsConfirmed', () => {
    let entities
    beforeAll(() => {
      business.documents = [
        {
          status: 'approve_and_commit',
          files: []
        },
        {
          status: 'not_required',
          files: []
        },
        {
          status: 'pending_review',
          files: []
        }
      ]
    })
    it('when documnets are not approved', () => {
      entities = [ business ]
      expect(wrapper.instance().documentsConfirmed(entities)).toBeFalsy()
    })
    it('when documnets are approved', () => {
      business.documents[2].status = 'not_required'
      entities = [ business ]
      expect(wrapper.instance().documentsConfirmed(entities)).toBeTruthy()
    })
  })

  describe('#directUrlToGlobalSearchPage', () => {
    it('returns url to global search page', () => {
      const object = wrapper.instance().directUrlToGlobalSearchPage(props.loan.appNumber)
      expect(object).toEqual('/admin/loans/123456')
    })
  })

  describe("#onStatusChange", () => {
    it("onStatusChange has been called", () => {
      let testReferenceFiles = [{
        details: null,
        fileStatus: "PENDING_REVIEW",
        isNew: true,
        name: "sample-pdf-file_2021-11-08_14_21_18_UTC_5f3cb44c.pdf",
        referenceDate: "2021-11-08",
        rid: 817983212,
        status: "PENDING",
        trimmedFilename: "sample-pdf-file.pdf",
        uuid: "92dd03d6-6d02-4a89-bbff-39add7ee7b29",
      }]
      testReferenceFiles = JSON.stringify(testReferenceFiles)
      wrapper.setProps({
        document: {
          ...docProps,
          referenceFiles: testReferenceFiles,
          files: [{ name: 'test_2' }],
          fileUrls: [{ filename: 'one' }]
        }
      })

      let mockedValue = () => { value : true }
      const instance = wrapper.instance();
      let spy = jest.spyOn(instance, 'updateStatusBucket').mockReturnValue(mockedValue)
      instance.onStatusChange({target: 'test'});

      expect(spy).toHaveBeenCalled();
    });
  });

})
